import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Alert,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { setFormModal } from "../redux/slices/modalSlice";
import { useDispatch } from "react-redux";
import { addmembershipFormSchema } from "../utils/formValidationSchema";
import {
  uploadedMembers,
  fetchUploadedMembers,
} from "../redux/slices/membershipMgtSlice";
import { fetchMemberType } from "../redux/slices/membershipTypeSlice";

const AddMemberMgt = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState("");
  const [type, setType] = useState([]);
  const [memberValue, setMemberValue] = useState(""); 

  const initialValues = {
    memberShipCode: "",
    firstName: "",
    lastName: "",
    // email:'',
    phoneNumber: "",
    membershipType: "",
    // dateJoined: "",
  };

    useEffect(() => {
      async function getMembershipType() {
      const response = await dispatch(fetchMemberType());
      const payload = response?.payload;

      if (Array.isArray(payload)) {
        setType(payload);
      } else if (Array.isArray(payload?.data)) {
        setType(payload.data);
      } else {
        setType([]);
      }
    }
   getMembershipType();
  }, [dispatch]);

  const memberOptions = type.map((member) => ({
    label: member.name,
    value: member.id,
  }));

  const handleSubmit = async (values) => {
    setLoading(true);
    setError("");
    
    try {
      const formData = {
        memberShipCode: values.memberShipCode,
        firstName: values.firstName,
        lastName: values.lastName,
        // email:values.email,
        phoneNumber: values.phoneNumber,
        membershipType: memberValue, 
        // dateJoined:values.dateJoined,
        // "isActive": true,
      };
     
      
      const response = await dispatch(uploadedMembers(formData));

      if (!response?.payload?.isSuccessful) {
        setLoading(false);
        setError(
          response?.payload?.message || "Something went wrong. Please try again"
        );
        dispatch(fetchUploadedMembers());
        return;
      }

      setSuccess(
          response?.payload?.successMessage
        );
      setLoading(false);
      dispatch(setFormModal({ status: false }));
      
       

      dispatch(fetchUploadedMembers()); 
    } catch (error) {
      setError(error?.message || "Something went wrong. Please try again");
    }
     
  };

  return (
    <>

    {success && (
                  <Alert status="success" mb={4}>
                    <AlertIcon />
                    <AlertTitle>{success}</AlertTitle>
                  </Alert>
                )}

      {error && (
        <Alert status="error" mb={4}>
          <AlertIcon />
          <AlertTitle>{error}</AlertTitle>
        </Alert>
      )}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={addmembershipFormSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ errors, touched, values, handleBlur, handleChange }) => (
          <Form>
            <FormControl
              mt={4}
              isInvalid={errors.memberShipCode && touched.memberShipCode}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="memberShipCode" fontSize={"16px"}>
                Membership code
              </FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="memberShipCode"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="text"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.memberShipCode}
              />
              {touched.memberShipCode && errors.memberShipCode && (
                <FormErrorMessage>{errors.memberShipCode}</FormErrorMessage>
              )}
            </FormControl>
            
            <FormControl
              mt={4}
              isInvalid={errors.firstName && touched.firstName}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="firstName" fontSize={"16px"}>
                First Name
              </FormLabel>
              <Input
                placeholder="Enter First Name"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="firstName"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="text"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.firstName}
              />
              {touched.firstName && errors.firstName && (
                <FormErrorMessage>{errors.firstName}</FormErrorMessage>
              )}
            </FormControl>
            
            <FormControl
              mt={4}
              isInvalid={errors.lastName && touched.lastName}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="lastName" fontSize={"16px"}>
                Last Name
              </FormLabel>
              <Input
                placeholder="Enter Last Name"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="lastName"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="text"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.lastName}
              />
              {touched.lastName && errors.lastName && (
                <FormErrorMessage>{errors.lastName}</FormErrorMessage>
              )}
            </FormControl>
            
            {/* <FormControl mt={4} isInvalid={errors.email && touched.email}
            color="#121212" fontFamily={'inter'}>
          <FormLabel htmlFor='email' fontSize={"16px"}>Email Address</FormLabel>
          <Input
            placeholder="Enter Email Address"
            fontSize={"small"}
            bg={'#F3F3F3'}
            name="email"
            focusBorderColor="#ffffff"
            borderRadius={'0'}
            borderColor={"#FFFFFF"}
            _placeholder={{ color: "#B4B1B1" }}
            _hover={{ borderColor: "#FFFFFF" }}
            type="text"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values?.email}
          />
          {touched.email && errors.email && (
            <FormErrorMessage>{errors.email}</FormErrorMessage>
          )}
        </FormControl> */}
        
            <FormControl
              mt={4}
              isInvalid={errors.phoneNumber && touched.phoneNumber}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="phoneNumber" fontSize={"16px"}>
                Phone Number
              </FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="phoneNumber"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="tel"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.phoneNumber}
              />
              {touched.phoneNumber && errors.phoneNumber && (
                <FormErrorMessage>{errors.phoneNumber}</FormErrorMessage>
              )}
            </FormControl>

            <FormControl 
              mt={4} 
              color="#121212" 
              fontFamily={"inter"}
              isInvalid={!memberValue && error} 
            >
              <FormLabel fontSize={"16px"}>Membership Type</FormLabel>
              <Select
                placeholder="Select Membership Type"
                name="membershipType"
                value={memberValue} 
                onChange={(e) => setMemberValue(e.target.value)} 
                bg="#F3F3F3"
                fontSize="small"
                borderRadius="0"
                borderColor="#FFFFFF"
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                focusBorderColor="#ffffff"
              >
                {memberOptions.map((option) => (
                  <option key={option.value} value={option.label}>
                    {option.label}
                  </option>
                ))}  
              </Select>
              {!memberValue && error && (
                <FormErrorMessage>Please select a membership type</FormErrorMessage>
              )}
            </FormControl>

            <Button
              mt={10}
              width={"100%"}
              background={"#22944E"}
              _hover={{ background: "#1e7d42" }} 
              color={"#FFFFFF"}
              type="submit"
              isLoading={loading}
              loadingText="Saving ..."
              isDisabled={!memberValue} // Disable if no membership type selected
            >
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddMemberMgt;